module.exports = __webpack_public_path__ + "img/aogiri.8d56e035.jpg";